import CloseIcon from './icons/close.svg'
import InfoIcon from './icons/info.svg'
import LearnMoreIcon from './icons/learn_more.svg'
import PauseIcon from './icons/pause.svg'
import PlayIcon from './icons/play.svg'
import PoweredByIcon from './icons/powered_by.png'
import PoweredByIconWhite from './icons/powered_by_white.png'
import PoweredByForActivity from './icons/powered_by_for_activity.png'
import SettingsIcon from './icons/speed_arrow.svg'
import ShareIcon from './icons/share.svg'
import TranscriptIcon from './icons/transcript.svg'
import VolumeIcon from './icons/volume.svg'

export default {
  components: {
    CloseIcon,
    InfoIcon,
    LearnMoreIcon,
    PauseIcon,
    PlayIcon,
    // PoweredByIcon
    SettingsIcon,
    ShareIcon,
    TranscriptIcon,
    VolumeIcon
  },

  data() {
    return {
      icons: {
        powered_by: PoweredByIcon,
        powered_by_white: PoweredByIconWhite,
        powered_by_for_activity: PoweredByForActivity
      }
    }
  }

}
